@let texts = resourcesService.languageFile.value();
<div class="feedback-inner-container" role="status"> <!-- //NOSONAR -->
  @if (feedbackValue) {
    <div [class]="{visible, wrong: feedbackValue !== 'correct', correct: feedbackValue === 'correct'}"
         class="feedback-value">
      @if (feedbackValue === 'correct') {
        <div>
          <span class="bold">{{ texts.correct }}&nbsp;</span>
          <span>{{ texts.pointsEarned.replace('%%', computeScore().toString()) }}</span>
        </div>
      }
      @if (feedbackValue === 'wrong') {
        <div >
          <span>{{texts.wrongAnswerFeedback}}</span>
        </div>
      }
      @if (feedbackValue === 'wrong-and-over') {
        <div>
          <span>{{texts.wrongAnswerAndOverFeedback}}</span>
        </div>
      }
    </div>
  }
</div>
